import { Model } from "@tailflow/laravel-orion/lib/model";

export class Country extends Model<{
  name: string;
  code: string;
  created_at: string;
  updated_at: string;
}> {
  public $resource(): string {
    return "countries";
  }
}
